var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: ['common-icon-container', !_vm.isPC && 'common-icon-container-mobile'],
    style: {
      padding: _vm.iconHotAreaSize
    },
    on: {
      "click": _vm.handleImgClick
    }
  }, [_vm.isApp ? _c('image', {
    staticClass: "common-icon",
    style: {
      width: _vm.iconWidth,
      height: _vm.iconHeight
    },
    attrs: {
      "src": _vm.props.file
    }
  }) : _c('img', {
    staticClass: "common-icon",
    style: {
      width: _vm.iconWidth,
      height: _vm.iconHeight
    },
    attrs: {
      "src": _vm.props.file
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }